import { SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const SectionRow = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
`;

export const GeographicExposureWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const LoadingSkeleton = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '100%',
        height: '180px',
        borderRadius: '8px',
      },
    },
  ],
})``;
